<template>
    <div>
        <s-button @onclick="addEmail" label="Ajouter une configuration d'email" theme="is-primary"/>
        <div v-for="email in emails" class="listAdhesion" v-on:click="edit(email)"
            :class="email.enabled ? 'listAdhesion' : 'listAdhesion desactive'"
        >
            <div style="float:right;text-align:right">
                <span v-show="email.enabled">ACTIVE</span>
                <span v-show="!email.enabled">DESACTIVE</span>
                <br/>
                {{email.nb}} mail(s) envoyé(s)
            </div>
            <div>{{email.id}}</div>
            <div>{{email.description}}</div>
        </div>
        <s-modal 
            :open="modalEmail"
            :close="true"
            @close="modalEmail=false"
            :save="true"
            @save="save"
            title="Configuration de l'email"
        >
         <div style="width: 100%">
                <div class="notModify">
                    <div style="float:right">
                    <s-button icon="" label="Sup.." theme="is-danger is-small" @onclick="deleteEmail(email)"/>
                    </div>
                    NE PAS MODIFIER :
                <div>
                ID: <s-input 
                        v-model="email.id"
                        theme="is-danger is-normal"
                        
                    /> 
                </div>
                <div style="margin-top: 10px">
                Paramètres : <input 
                        v-model="email.values"
                        theme="is-danger is-normal"
                        class="input is-danger"
                    /> 
                </div>
                </div>
            <hr/>
            <div style="text-align:left;">
                CE QU ON PEUT PARAMETRER :
              <div>
                Description (non visible des utilisateurs c'est pour nous réperer): <textarea v-model="email.description" cols="100" rows="3"/>
            </div>
            <div style="margin-top: 10px">
                 <s-switch id="smail" @change="status=email.enabled=!email.enabled" :defaultState="email.enabled" labelEnableText="Email activé" labelDisableText="Email déactivé"/>
            </div>
             <div style="margin-top: 10px">
                Objet du mail : 
                <textarea v-model="email.subject" cols="100" rows="3"/>
            </div>
            
            <div>
                Description du mail :
                <quill-editor v-model="email.html"
                        ref="myQuillEditor"
                        :options="editorOption"
                        :disabled="false"
                >
                </quill-editor>
            </div>
            </div>
            <hr/>
             <div style="float:right">
            <s-button icon="" label="Tester l'email" theme="is-primary" @onclick="openTestEmail(email)"/>
            </div>
            
         </div>
        </s-modal>
        <s-modal
            title="Tester l'email"
            :open="modalTestEmail"
            @close="modalTestEmail=false"
            :close="true"
        >
            <s-input type="text" v-model="emailInput" placeholder=""/>
            <div v-for="value in values" style="text-align:left">
                <div v-if="value!='url'">
                <div style="width:100px;display:inline-block;margin:5px;">{{value}}</div> <s-input theme="is-primary" v-model="params[value]" width="200px"/>
                </div>
            </div>
            <div style="text-align:left">
                url : {{this.url}}
            </div>
            <s-button label="M envoyer le test d email sur ma boite"
                @onclick="sendEmail()"
                theme="is-primary"
                icon=""/>
        </s-modal>
    </div>
</template>
<style scoped>
    .desactive {
         background-color: rgb(192, 194, 192);
    }
    .notModify {
        text-align:left;
        color:white;
        font-weight: bolder;
        background-color: rgb(228, 149, 149);
        padding:10px;
    }
    
    .listAdhesion {
        text-align: left;
        margin: 20px;
        padding: 5px;
        border: thin black solid;
        color: black;
    }
    .listAdhesion:hover {
        cursor: pointer;
        background-color: rgb(165, 223, 165);
    }
</style>
<script>
import email_fct from "@/firebase/mails"
import firebase_api from '@/firebase/firebase_api'
export default {
    data() {
        return {
            emails: [],
            params: {},
            values: [],
            emailInput: "",
            modalEmail: false,
            modalTestEmail: false,
            email: {
                id: null,
                description: "",
                values: "",
                html: "",
                subject: "",
                enabled: true
            },
            editorOption: {
            theme: 'snow',
             
             modules: {
                 
                 toolbar: [
                [{'size': ['small', false, 'large', 'huge']}],
                 ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
                 [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                 [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
                 ['clean'], ['link'] 
                 ],
                 
             }
        }
        }
    },
    computed: {
        url() {
            return  window.location.origin;
        }
    },
    mounted() {
        this.$bind("emails", firebase_api.api.getDb().collection("admin_email"))
    },
    methods: {
        sendEmail() {
           
            this.params['url'] =  this.url;
            email_fct.object.sendEmail(this.emailInput, this.email.id, this.params);
            this.modalTestEmail=false;
            
        },
        openTestEmail(email) {
            this.values = email.values.split(",");
            this.emailInput = this.$store.getters.getUser.email;
            this.modalTestEmail=true;
        },
        addEmail() {
            this.email= {
                id: null,
                description: "",
                values: "",
                html: "",
                subject: "",
                enabled: true
            }
            this.modalEmail=true;
        },
        edit(email) {
            this.email = email;
            this.modalEmail=true;
        },
        save() {
            firebase_api.api.getDb().collection("admin_email").doc(this.email.id).set (
                this.email
            )
             this.modalEmail=false;
        },
        deleteEmail(email) {
            if (confirm("SUPPRIMER ?")) {
                firebase_api.api.getDb().collection("admin_email").doc(email.id).delete();
                this.modalEmail=false;
            }
        }
    }
}
</script>